import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

firebase.initializeApp({
  apiKey: 'AIzaSyCazss0S8al5bPtzbYjzOhIbOpdD_FOuRQ',
  authDomain: 'zuversicht.firebaseapp.com',
  databaseURL: 'https://zuversicht.firebaseio.com',
  projectId: 'zuversicht',
  storageBucket: 'zuversicht.appspot.com',
  messagingSenderId: '356398122421',
  appId: '1:356398122421:web:661b338ce7ecda61b645fc'
})

const firestore = firebase.firestore()

export default new Vuex.Store({
  state: {
    loading: false,
    posts: []
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setLoadedPosts (state, payload) {
      state.posts = payload
    }
  },
  actions: {
    loadPosts ({
      commit
    }) {
      firestore.collection('posts').orderBy('votes').get()
        .then(function (querySnapshot) {
          const posts = []
          querySnapshot.forEach(function (doc) {
            const obj = doc.data()
            posts.push({
              id: doc.id,
              ...obj
            })
          })
          commit('setLoadedPosts', posts)
        })
    }
  },
  getters: {
    getPosts (state) {
      return state.posts.reverse()
    },
    loading (state) {
      return state.loading
    }
  }
})
